export interface AppConfig {
  NODE_ENV: string;
  ADMIN_UI_GTM_KEY: string;
  AUTH_UI_URL: string;
  SURVEY_UI_URL: string;
  RESPONDENT_UI_URL: string;
  REPORT_API_CLIENT_URL: string;
  REPORT_UI_URL: string;
  ADMIN_API_CLIENT_URL: string;
  AUTH_API_CLIENT_URL: string;
  RECAPTCHA_SITE_KEY: string;
  GROWTHBOOK_API_KEY: string;
  DATADOG_ADMIN_UI_CLIENT_TOKEN: string;
  DATADOG_ADMIN_UI_RUM_APPLICATION_ID: string;
  DATADOG_ADMIN_UI_RUM_DEFAULT_PRIVACY_LEVEL: string;
  DATADOG_ADMIN_UI_RUM_SESSION_REPLAY_SAMPLE_RATE: string;
  DATADOG_ADMIN_UI_RUM_SESSION_SAMPLE_RATE: string;
  REACT_APP_PUBLIC_POSTHOG_HOST: string;
  REACT_APP_PUBLIC_POSTHOG_KEY: string;
  INTERCOM_APP_ID: string;
  INTERCOM_MESSENGER_STYLE_ID: string;
}

/**
 * Get app config. During development is uses values from env variables.
 * On prod it return global config object
 *
 * This enables single Docker image build to be run with different configs.
 */
export const getAppConfig = (): AppConfig => {
  /**
   * In development use env variables
   */
  if (process.env.NODE_ENV === 'development') {
    return {
      NODE_ENV: process.env.NODE_ENV,
      ADMIN_UI_GTM_KEY: process.env.ADMIN_UI_GTM_KEY,
      AUTH_UI_URL: process.env.AUTH_UI_URL,
      SURVEY_UI_URL: process.env.SURVEY_UI_URL,
      RESPONDENT_UI_URL: process.env.RESPONDENT_UI_URL,
      REPORT_API_CLIENT_URL: process.env.REPORT_API_CLIENT_URL,
      REPORT_UI_URL: process.env.REPORT_UI_URL,
      ADMIN_API_CLIENT_URL: process.env.ADMIN_API_CLIENT_URL,
      AUTH_API_CLIENT_URL: process.env.AUTH_API_CLIENT_URL,
      RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
      GROWTHBOOK_API_KEY: process.env.GROWTHBOOK_API_KEY,
      DATADOG_ADMIN_UI_CLIENT_TOKEN: process.env.DATADOG_ADMIN_UI_CLIENT_TOKEN,
      DATADOG_ADMIN_UI_RUM_APPLICATION_ID: process.env.DATADOG_ADMIN_UI_RUM_APPLICATION_ID,
      DATADOG_ADMIN_UI_RUM_DEFAULT_PRIVACY_LEVEL:
        process.env.DATADOG_ADMIN_UI_RUM_DEFAULT_PRIVACY_LEVEL,
      DATADOG_ADMIN_UI_RUM_SESSION_REPLAY_SAMPLE_RATE:
        process.env.DATADOG_ADMIN_UI_RUM_SESSION_REPLAY_SAMPLE_RATE,
      DATADOG_ADMIN_UI_RUM_SESSION_SAMPLE_RATE:
        process.env.DATADOG_ADMIN_UI_RUM_SESSION_SAMPLE_RATE,
      REACT_APP_PUBLIC_POSTHOG_HOST: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
      REACT_APP_PUBLIC_POSTHOG_KEY: process.env.REACT_APP_PUBLIC_POSTHOG_KEY,
      INTERCOM_APP_ID: process.env.INTERCOM_APP_ID,
      INTERCOM_MESSENGER_STYLE_ID: process.env.INTERCOM_MESSENGER_STYLE_ID,
    };
  }

  if (!window || !window.AppConfig) {
    throw new Error('APP CONFIG MISSING!');
  }

  const appConfigShallowCopy = {
    ...window.AppConfig,
  };

  return appConfigShallowCopy;
};
